export interface InventorySuperviseurOption {
  value: string;
  label: string;
}

export const SUPERVISEUR_OPTIONS: InventorySuperviseurOption[] = [
  { value: 'Claire Dubois', label: 'Claire Dubois' },
  { value: 'Thomas Leroy', label: 'Thomas Leroy' },
  { value: 'Sophie Bernard', label: 'Sophie Bernard' },
  { value: 'Marc Fontaine', label: 'Marc Fontaine' },
  { value: 'Élise Garnier', label: 'Élise Garnier' },
  { value: 'Hugo Marchand', label: 'Hugo Marchand' },
];
